import { NavigateWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Navigate')
export class NavigateNodeSchemaProvider extends SchemaProvider<NavigateWorkflowNode> {}
